/**
 * Application Configuration
 * Centralized configuration untuk environment variables dan app settings
 */

const getEnvVar = (key, defaultValue = null) => {
  const value = process.env[`REACT_APP_${key}`];
  if (value === undefined || value === '') {
    return defaultValue;
  }
  
  // Safety check: Jangan izinkan localhost di production
  if (key === 'API_URL' && value.includes('localhost')) {
    const nodeEnv = process.env.NODE_ENV || 'development';
    if (nodeEnv === 'production') {
      return defaultValue;
    }
  }
  
  return value;
};

const validateConfig = () => {
  const errors = [];
  
  // Validasi API URL - gunakan default value untuk validasi
  const apiUrl = getEnvVar('API_URL', 'https://mosqify-api.vercel.app/api/v1');
  try {
    new URL(apiUrl);
  } catch (e) {
    errors.push('REACT_APP_API_URL must be a valid URL');
  }

  // Validasi environment
  const nodeEnv = process.env.NODE_ENV || 'development';
  if (!['development', 'production', 'test'].includes(nodeEnv)) {
    errors.push(`Invalid NODE_ENV: ${nodeEnv}`);
  }

  // Jangan throw error di production, hanya log warning
  if (errors.length > 0) {
    // Di production, kita tidak throw error karena sudah ada default values
    // Hanya log warning untuk debugging
  }
};

// Configuration object
const config = {
  // API Configuration
  api: {
    // Default ke localhost API di development, production API di production
    // Bisa di-override dengan REACT_APP_API_URL environment variable
    // TAPI jika environment variable berisi localhost di production, akan di-ignore
    baseUrl: (() => {
      const nodeEnv = process.env.NODE_ENV || 'development';
      
      // Default URLs berdasarkan environment
      const defaultLocalUrl = 'http://localhost:3001/api/v1';
      const defaultProductionUrl = 'https://mosqify-api.vercel.app/api/v1';
      
      // Log untuk debugging
      console.log('[appConfig] NODE_ENV:', nodeEnv);
      console.log('[appConfig] REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
      
      // Jika ada environment variable, gunakan itu (highest priority)
      const envUrl = getEnvVar('API_URL', null);
      if (envUrl) {
        console.log('[appConfig] Using environment variable API URL:', envUrl);
        // Hard block: Jangan izinkan localhost di production
        if (nodeEnv === 'production' && envUrl.includes('localhost')) {
          console.warn('[appConfig] Blocked localhost API in production, using production URL');
          return defaultProductionUrl;
        }
        return envUrl;
      }
      
      // Default: selalu gunakan PRODUCTION API kecuali explicitly set
      // User harus menggunakan npm run start:local untuk local API
      console.log('[appConfig] No REACT_APP_API_URL set, using PRODUCTION API by default');
      console.log('[appConfig] 💡 To use local API, run: npm run start:local');
      return defaultProductionUrl;
    })(),
    timeout: parseInt(getEnvVar('API_TIMEOUT', '15000'), 10),
  },

  // Environment
  env: process.env.NODE_ENV || 'development',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',

  // Features
  features: {
    enableLogging: getEnvVar('ENABLE_LOGGING', 'true') === 'true',
    enableAnalytics: getEnvVar('ENABLE_ANALYTICS', 'false') === 'true',
  },

  // Prayer Times API
  prayerTimes: {
    apiUrl: getEnvVar('PRAYER_TIMES_API_URL', 'https://api.aladhan.com/v1'),
    defaultCity: getEnvVar('PRAYER_TIMES_CITY', 'Jakarta'),
    defaultCountry: getEnvVar('PRAYER_TIMES_COUNTRY', 'Indonesia'),
    defaultMethod: parseInt(getEnvVar('PRAYER_TIMES_METHOD', '20'), 10),
  },

  // Al-Quran API
  quran: {
    apiUrl: getEnvVar('QURAN_API_URL', 'https://equran.id/api/v2'),
  },

  // Neon Auth Configuration
  neonAuth: {
    baseUrl: getEnvVar('NEON_AUTH_URL', null), // Will be constructed in service if not provided
    enabled: getEnvVar('NEON_AUTH_ENABLED', 'true') === 'true',
  },
};

// Validate configuration saat module di-load
if (typeof window !== 'undefined') {
  validateConfig();
  
  // Log API URL yang digunakan
  const apiUrl = config.api.baseUrl;
  if (apiUrl.includes('localhost')) {
    if (config.isProduction) {
      console.error('[appConfig] ERROR: Using localhost API in production! This should not happen.');
    } else {
      console.log('[appConfig] ✅ Using LOCAL API:', apiUrl);
      console.log('[appConfig] 💡 To use production API, run: npm run start:prod');
    }
  } else {
    console.log('[appConfig] ✅ Using PRODUCTION API:', apiUrl);
    if (config.isDevelopment) {
      console.log('[appConfig] 💡 To use local API, run: npm run start:local');
    }
  }
}

export default config;

